import { deleteApiCaller, getApiCaller, postFormDataApiCaller, putApiCaller, putFormDataApiCaller } from "../apiCaller";

export const getBookCategories = async (currentPage, itemsPerPage, search, tree = false, parentId = undefined) => {
    const treeParam = tree ? '&tree=true' : '';
    let url = `book-category/get-all?page=${currentPage}&limit=${itemsPerPage}&search=${search}${treeParam}&includeHidden=true`;
    if (parentId !== undefined) {
        url += `&parentId=${parentId}`;
    }
    const response = await getApiCaller(url);
    return response;
}

export const getBookCategoriesDropdown = async () => {
    const response = await getApiCaller("book-category/dropdown");
    return response;
}

export const getBookCategoryById = async (id) => {
    const response = await getApiCaller(`book-category/${id}`);
    return response;
}

export const getBooksByCategoryId = async (id, currentPage, itemsPerPage) => {
    const response = await getApiCaller(`book-category/${id}/books?page=${currentPage}&limit=${itemsPerPage}&includeHidden=true`);
    return response;
}

export const addBookCategory = async (payload) => {
    const response = await postFormDataApiCaller("book-category/create", payload);
    return response;
}

export const updateBookCategory = async (id, payload) => {
    const response = await putFormDataApiCaller(`book-category/update/${id}`, payload);
    return response;
}

export const deleteBookCategory = async (id) => {
    const response = await deleteApiCaller(`book-category/delete/${id}`);
    return response;
}

export const bookCategorySequence = async (payload) => {
    const response = await putApiCaller("book-category/sequence", payload);
    return response;
}

export const getCategoryChildren = async (id) => {
    const response = await getApiCaller(`book-category/${id}/children`);
    return response;
}

export const getCategoryAncestors = async (id) => {
    const response = await getApiCaller(`book-category/${id}/ancestors`);
    return response;
}

export const swapBookCategoryWithPage = async (payload) => {
    const response = await putApiCaller("book-category/swap-page", payload);
    return response;
}
